import {connect} from 'react-redux';
import SignUp from  '../../templates/SignUp';

//Binding the data
const mapStateToProps = (state) => {
    return {
        loginStatus: state.loginStatus, // Gets the current login status in the store
        language: state.currentLanguage // Gets the current language (es, en, sv)
    }
}

export default connect(mapStateToProps, null)(SignUp);


// WEBPACK FOOTER //
// ./src/redux/components/pages/SignUp/SignUpContainer.js